import React from 'react'
import ExperienceHerosection from './sections/ExperienceHerosection';
import DesignCapability from './sections/DesignCapability';
import ReadRedesignyourexperience from './sections/ReadRedesignyourexperience';
import ResearchFirst from './sections/ResearchFirst';
const ExperinceDesign = () => {
  return (
    <>
    <ExperienceHerosection/>
    <DesignCapability/>
    <ResearchFirst/>
    <ReadRedesignyourexperience />
    </>
    
  )
}

export default ExperinceDesign